export const translationLivechat_en_part2 = {
  livechatFailedTransferSession: "Failed to transfer the livechat session.",
  livechatFailedCloseSession: "Failed to close the livechat session.",
  livechatFailedLoadSessions: "Failed to load livechat sessions.",
  livechatFailedLoadSession: "Failed to load the livechat session.",
  livechatSessionUnavailableTitle: "Conversation no longer available",
  livechatSessionUnavailableDescription:
    "It may have been deleted, for example because the visitor deleted their data.",
  livechatFailedLoadTranscript: "Failed to load livechat transcript.",
  livechatFailedLoadAiContext: "Failed to load AI context.",
  livechatFailedLoadAgents: "Failed to load livechat agents.",
  livechatFailedLoadSettings: "Failed to load livechat settings.",
  livechatFailedSaveSettings: "Failed to save livechat settings.",
  livechatCloseReasonDashboard: "Closed from dashboard livechat workspace",
  livechatConversationSelectTitle: "Select a livechat session",
  livechatConversationSelectHint:
    "Choose a waiting, active, or closed session to view the full conversation and support context.",
  livechatLiveSession: "Live session",
  livechatJoinSession: "Join session",
  livechatJoining: "Joining...",
  livechatTakeoverProviderControl: "Take over",
  livechatTakingOverProviderControl: "Taking over...",
  livechatTransferSession: "Transfer",
  livechatTransferredToYou: "Transferred to you",
  livechatTransferReceivedTitle: "Conversation transferred to you",
  livechatTransferReceivedOpen: "Open conversation",
  livechatTransferReceivedOsBody: "A conversation was transferred to you.",
  livechatTransferReceivedOsBodyFrom: "{agent} transferred a conversation to you.",
  livechatSessionTakenOverTitle: "Conversation taken over",
  livechatSessionTakenOverOsBody: "Another agent took over the conversation from you.",
  livechatSessionTakenOverOsBodyFrom: "{agent} took over the conversation from you.",
  livechatTransferTargetLabel: "Transfer to",
  livechatTransferNoTargets: "No other agents are available for this chatbot.",
  livechatTransferConfirm: "Transfer session",
  livechatTransferring: "Transferring...",
  livechatTakeoverSession: "Take over session",
  livechatTakingOverSession: "Taking over...",
  livechatCloseSession: "Close session",
  livechatSessionClosed: "Session closed",
  livechatClosing: "Closing...",
  livechatSessionContext: "Session context",
  livechatSessionMetadata: "Metadata · Unverified",
  livechatSessionMetadataHint: "Provided by the visitor’s browser. These values are not verified.",
  livechatMetadataShowAll: "Show all ({count})",
  livechatMetadataHide: "Hide",
  livechatSessionContextEnvironment: "Environment",
  livechatSessionContextVisitorSession: "Visitor session",
  livechatSessionContextLivechat: "Livechat",
  livechatSessionContextRequested: "Requested",
  livechatSessionContextAgentJoined: "Agent joined",
  livechatSessionContextClosed: "Closed",
  livechatProvidedInformation: "Provided information",
  livechatNotAvailable: "Not available",
  livechatFeedback: "Feedback",
  livechatFeedbackSubmitted: "Submitted",
  livechatFeedbackSubmittedLine: "Submitted {datetime}",
  livechatNoFeedbackYet: "No customer feedback submitted.",
  livechatWaitingForRating: "Waiting for customer rating.",
  livechatCustomerTypingBadge: "Customer typing",
  livechatAiContextBeforeJoined: "AI context before agent joined",
  livechatLoadingOlderContext: "Loading older context...",
  livechatLoadingAiContext: "Loading AI context...",
  livechatBeforeLivechatRequest: "Before livechat request",
  livechatAiSessionEnded: "AI session ended",
  livechatWhileWaitingInQueue: "While waiting in queue",
  livechatNoAiContext: "No AI context is available.",
  livechatContextBeforeAgentJoined: "Context before agent joined",
  livechatLivechatTranscript: "Livechat transcript",
  livechatSelectLanguageOption: "Select language",
  livechatTranslateTranscriptLanguage: "Select language for livechat transcript translation",
  livechatTranslateTranscript: "Translate",
  livechatTranslatingTranscript: "Translating...",
  livechatFailedTranslateTranscript: "Failed to translate livechat transcript.",
  livechatTranslatedFrom: "Translated from {language}",
  livechatShowOriginal: "Show original",
  livechatShowTranslation: "Show translation",
  livechatLanguageNameCs: "Czech",
  livechatLanguageNameDa: "Danish",
  livechatLanguageNameDe: "German",
  livechatLanguageNameEn: "English",
  livechatLanguageNameEs: "Spanish",
  livechatLanguageNameFi: "Finnish",
  livechatLanguageNameFr: "French",
  livechatLanguageNameIt: "Italian",
  livechatLanguageNameNl: "Dutch",
  livechatLanguageNameNo: "Norwegian",
  livechatLanguageNamePl: "Polish",
  livechatLanguageNameSv: "Swedish",
  livechatLoadingContext: "Loading context...",
  livechatNoContextAvailable: "No context is available.",
  livechatLoadingOlderMessages: "Loading older messages...",
  livechatLoadingTranscript: "Loading transcript...",
  livechatNoMessagesYet: "No messages have been exchanged yet.",
  livechatCustomerIsTyping: "Customer is typing...",
  livechatComposerReplyPlaceholder: "Reply to the customer...",
  livechatComposerJoinToReply: "Join the session to start replying.",
  livechatComposerTakeoverToReply: "Take over the session to start replying.",
  livechatComposerProviderOwned: "The provider is handling this session.",
  livechatComposerOtherAgent: "Another agent is handling this session.",
  livechatComposerSessionClosed: "This session has been closed.",
  livechatComposerSaveProfile: "Save your profile to enable livechat replies.",
  livechatAttachmentsSelected: "{count} attachment selected",
  livechatAttachmentsSelectedPlural: "{count} attachments selected",
  livechatSendReply: "Send reply",
  livechatSending: "Sending...",
  livechatFailedSendMessage: "Failed to send the message.",
  livechatFailedReadFile: "Could not read {filename}.",
  livechatAttachmentFallback: "Attachment",
  livechatSaveProfileBeforeJoin:
    "Save your livechat profile before joining or replying to sessions for this chatbot.",
  livechatSetProfile: "Set profile",
  livechatAssignedToOtherAgent: "This session is currently assigned to ",
  livechatProviderOwnedNotice: "The provider is handling this session",
  livechatAnotherAgent: "another agent",
  livechatProfileModalTitle: "Livechat agent profile",
  livechatProfileModalEyebrow: "{chatbotId} · {env} environment",
  livechatProfileLoading: "Loading the active profile...",
  livechatProfileActivePrefix: "Active profile:",
  livechatProfileNoneYet: "No livechat profile has been saved for {chatbotId} yet.",
  livechatProfileNoChatbot: "No chatbot",
  livechatDisplayName: "Display name",
  livechatAgentSpokenLanguages: "Languages you write in",
  livechatAgentSpokenLanguagesHelp:
    "The customer's chat widget only translates your messages from these languages. Leave empty to allow any detected language (short replies may be misdetected). With multiple languages selected, detection picks among them.",
  livechatAvatarUrl: "Avatar URL",
  livechatAvatarPlaceholder: "https://cdn.example.com/avatar.png",
  livechatAvatarUploadImage: "Upload profile image",
};
